export default __webpack_public_path__ + "media/color/maid-5d8834fb.svg";